<template>
  <a-modal
      title="更换饭卡"
      :visible="showModal"
      @ok="clickOk"
      @cancel="showModal=false"
      class="customermodel"
      width="500px"
      :centered="true"
    >
      <div class="replacedcard-model">
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="卡号">
            <a-input size="large" v-model="newCard" />
          </a-form-item>
        </a-form>
        <a-row>
          <a-col :offset="4">
            <div class="tips fprimary">
              <b>注意：</b>饭卡更换后，旧饭卡将失效，请确认后再操作。
            </div>
          </a-col>
        </a-row>
      </div>
    </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import apis from '@/business/apis'
export default {
  inject: ['eventBus'],
  data () {
    return {
      data: {},
      newCard: '',
      showModal: false
    }
  },
  computed: {
    ...mapState('school', [
      'currentSchool'
    ])
  },
  methods: {
    async showThisModal (data) {
      this.newCard = ''
      this.showModal = true
      this.data = data
    },
    async clickOk () {
      this.newCard = this.newCard.trim()
      if (!this.newCard) {
        this.$message.info('卡号不能为空')
        return
      }
      if (this.newCard === this.data.card_num) {
        this.$message.info('卡号与原来一样')
        return
      }
      const data = {
        schoolId: this.currentSchool._id,
        cardNum: this.newCard,
        customerId: this.data.customer_id
      }
      const response = await this.$http.post(apis.user.changeMealCard, data)
      if (response.body.err) {
        return
      }
      this.data.card_num = response.body.card_number || this.newCard
      this.data.ic_card = response.body.ic_card
      this.showModal = false
    }
  },
  created () {
    this.eventBus.$on('show-change-mealcard-modal', this.showThisModal)
  },
  beforeDestroy () {
    this.eventBus.$off('show-change-mealcard-modal', this.showThisModal)
  }
}
</script>
